const getCharacters = (text, n) => {
    const textWithoutUrls = text.replace(/\(?<a.*?<\/a>\)?/gi, '');
    const pos = textWithoutUrls?.indexOf(' ', n);
    const out = textWithoutUrls?.substring(0, pos);
    return pos <= 0 ? text : out + '...';
};

export default getCharacters;
